<div  style="display:flex; flex-direction:row-reverse; justify-content: flex-end;" class="media-list">
    <ng-container *ngIf="listItem2 != null ">
        <pzl-media-item *ngFor="let item of listItem2" [item]="item"></pzl-media-item>
    </ng-container>
</div>
